import React, { Component } from 'react';
// import { useHistory } from 'react-router';
import { history } from '../../redux/store';
import { useEffect, useState } from 'react';
import moment from 'moment';
import axios from "axios";
import { Spin, Row, Col, Divider, DatePicker } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Form, Input, Switch, Space } from 'antd';
import { LoginOutlined } from '@ant-design/icons/lib';
import setting from '../../config/setting';
import PublicLayout from '../../layout/public/Public';
import { Link } from 'react-router-dom';
import { useForm } from 'antd/es/form/Form';
import { navigateHome } from '../../utils/naviagate-home';
import { navigateEmployeeHome } from '../../utils/navigate-employee-home';
import { useLocation, useParams } from "react-router-dom";
import metlogo from '../../assets/img/METLIFEWHT.png';
import msclogo from '../../assets/img/msclogo.png';

const { Item } = Form;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const EnterOtp = (props) => {

  const [otp, setOtp] = useState('');
  const [dob,setDob] = useState('');

  const token = useParams();


  //let history=useHistory();

  const location = useLocation();
  console.log("props :: ", location);

  const [empId, setEmpId] = useState(location?.state?.id);
  const [email, setEmail] = useState(location?.state?.email);
  const [logoType, setLogoType]=useState('metlife');
  const [form] = useForm();
  const [show,setShow]=useState(false);
  const [spin,setSpin]=useState(false);
  const [otpError,setOtpError]=useState(false);
  const [dobError,setDobError]=useState(false);

  useEffect(() => {
    console.log("token params::",token);
    console.log("loc params::",location.state);

    if(location && location.state == undefined){
      setEmail("");
      setEmpId("")
      localStorage.clear();
      history.push({ pathname: '/public/sign-in', state: {} });
    }
    const logoType =  localStorage.getItem("logoType");
    if(logoType){
      setLogoType(logoType);
    }

  }, []);


  function userName(event) {
    console.log("event name", event.target.value);
    setOtp(event.target.value);
  }



  function login() {
  // setSpin(true);
  setOtpError(false);
  setShow(false);
  setDobError(false);

  if(otp==="" ){
    setOtpError(true);
  }
  if(dob===""){
    setDobError(true);
  }
          if(otp && dob)
          { setDobError(false);
            setOtpError(false);
            setSpin(true);

              axios.post(setting.serverUrl + '/EmployeeVerifyOTP', {
                params: {
                  email: email,
                  Mobile:email,
                  otp : otp.trim() ,
                  empId : empId,
                  dob : dob
                  //dob:  moment(dob).format("YYYY-MM-DD")
                }
              }).then(response => {
                console.log("Response from login users", response)

                if (response && response.status == 200) {
                    console.log("connected user", response.data)
                    if(response.data && response.data.error){
                      // alert("OTP does not match.");
                      setShow(true);
                      setSpin(false);
                    }else if(response.data && response.data.error && response.data.error == 'user not found'){
                      setShow(true);
                      setSpin(false);
                      // alert('User not found')
                    }else if(response.data && response.data.id){
                      localStorage.setItem('employeeInfo', JSON.stringify(response.data));
                      navigateEmployeeHome();
                    }
                } else {
                    alert("Some technical issue. Please try again later");
                    console.log("Not connected user");
                    setSpin(false);
                }
              })
          }
          else
          {
            // setShow(true);
            // alert("Please enter correct OTP");
          }

    };


  return (

    <Row style={{
      height:'100%',
        backgroundImage: `url(${"covid_background.png"})`,
      backgroundSize: 'cover', backgroundPosition: '57% 50%', position: 'relative'
    }}>
      <Col span={7} style={{ height: '100%' }}>
        <div>

          <PublicLayout
          // bgImg={require('./wss.png')}
          >
            <h4 className='mt-0 mb-1'>Continue Login...</h4>

            <p
              style={{ color: '#161717' }}
            //className='text-color-200'
            > OTP for secure login on WSS Portal
            {/* We sent you an email with OTP number for secure login. Please enter the number you received in your email.  */}
            </p>



            <Form form={form} layout='vertical' className='mb-4'>
              <Item name='login' rules={[{ required: true, message: <></> }]}>
                <Input placeholder='Enter OTP received in registered Email' onChange={userName} />
                {otpError?<div style={{color:"red"}}>*OTP is Required</div>:""}
              </Item>


              <Item  rules={[{ required: true }]}>

                {/* <Input placeholder='Enter Date Of Birth' onChange={userName} /> */}
              <label>Enter Date of Birth </label>
                <DatePicker style={{width:'100%',borderRadius:20,height:"38px",background:"lavender"}}
                onChange={(date, dateString) =>setDob(moment(dateString).format("MM-DD-YYYY"))}   format="MM-DD-YYYY"
                />
                {dobError?<div style={{color:"red"}}>*Date of Birth is Required</div>:""}
              </Item>


              {show?<div style={{color:"red"}}>*Please enter valid OTP/DOB</div>:""}
              {spin? <div><Spin indicator={antIcon} /> <span style={{color:"white",padding:5}}>Verifying OTP/DOB......</span></div>  :""}
              <br></br>
              <Button
                block={false}
                type='primary'
                onClick={login}
                htmlType='submit'
                icon={<LoginOutlined style={{ fontSize: '1.3rem' }} />}
              >
                Verify OTP
        </Button>
            </Form>
            <br />

          </PublicLayout>
        </div>
      </Col>
      <Col span={17}


      //style={{}}
      >
        {
          logoType && logoType === 'metlife'?
          <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '20%', left: '30%' }}> <img src={metlogo} className='logo-img' /></h3>
          :
          logoType && logoType === 'msc'?
          <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '15%', left: '30%' }}> <img src={msclogo}  style={{width:250}} /></h3>
          :null
        }
        <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '40%', left: '20%' }}>WELCOME TO COVID-19 COMPLIANCE PORTAL</h3>
        {/* <img src={require('./wss.png')} style={{width:'100%',height:'fit-content'}} /> */}
      </Col>
    </Row>
  );
  // }
};

export default EnterOtp;
